var map = {
	"./adminprofile/list": [
		1900,
		20
	],
	"./agentprofile/list": [
		1901,
		23
	],
	"./ai_assistant/list": [
		1902,
		26
	],
	"./api_key/list": [
		1903,
		29
	],
	"./canned_answer/list": [
		1904,
		34
	],
	"./chat_configuration/list": [
		2069,
		4
	],
	"./client/list": [
		1905,
		37
	],
	"./destination_restrictor/list": [
		1906,
		39
	],
	"./disposition/list": [
		1907,
		42
	],
	"./field/list": [
		1908,
		45
	],
	"./form/list": [
		1909,
		48
	],
	"./form_website/list": [
		1910,
		51
	],
	"./gdpr/list": [
		1911,
		53
	],
	"./invoice/list": [
		1912,
		55
	],
	"./journey/list": [
		1913,
		61
	],
	"./journey_draft/list": [
		1914,
		64
	],
	"./journey_trigger/list": [
		1915,
		65
	],
	"./journey_variable/list": [
		1916,
		68
	],
	"./list/list": [
		1917,
		71
	],
	"./list_file/list": [
		1918,
		74
	],
	"./mail_account/list": [
		1919,
		77
	],
	"./operational_hours/list": [
		1920,
		80
	],
	"./organization/list": [
		1921,
		83
	],
	"./pause/list": [
		1922,
		86
	],
	"./phonenumber_monthly_cost/list": [
		1923,
		89
	],
	"./phonenumber_monthly_cost_parent/list": [
		1924,
		92
	],
	"./phonenumber_purchase/list": [
		1925,
		96
	],
	"./phonenumber_setup_cost/list": [
		1926,
		99
	],
	"./phonenumber_setup_cost_parent/list": [
		1927,
		102
	],
	"./points_system/list": [
		1928,
		106
	],
	"./prepaid_credit/list": [
		1929,
		109
	],
	"./queue/list": [
		1930,
		112
	],
	"./release/list": [
		1931,
		113
	],
	"./signature/list": [
		1932,
		116
	],
	"./skill/list": [
		1933,
		119
	],
	"./sla_policy/list": [
		1934,
		122
	],
	"./sound/list": [
		1935,
		125
	],
	"./stats_alarm/list": [
		1936,
		128
	],
	"./stats_custom_metric/list": [
		1937,
		131
	],
	"./stats_report/list": [
		1938,
		134
	],
	"./stats_widget/list": [
		1939,
		137
	],
	"./superadmin_profile/list": [
		1940,
		140
	],
	"./tag/list": [
		1941,
		143
	],
	"./tariff/list": [
		1942,
		146
	],
	"./tariff_parent/list": [
		1943,
		149
	],
	"./team/list": [
		1944,
		152
	],
	"./text_message_source/list": [
		1945,
		10
	],
	"./time_interval/list": [
		1946,
		156
	],
	"./user/list": [
		1947,
		159
	],
	"./voice_asterisk/list": [
		1948,
		162
	],
	"./voice_asterisk_downgrade/list": [
		1949,
		165
	],
	"./voice_recording_transcript_setting/list": [
		1950,
		169
	],
	"./voice_route/list": [
		1951,
		172
	],
	"./voice_shortcut/list": [
		1952,
		175
	],
	"./voice_trunk/list": [
		1953,
		178
	],
	"./voice_voicemail/list": [
		1954,
		181
	],
	"./wallboard/list": [
		1955,
		184
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1880;
module.exports = webpackAsyncContext;